:host {
  display: inline-block;
}

[data-record-type='Epic'] aha-icon,
[data-record-type='MasterFeature'] aha-icon {
  vertical-align: middle;
}
